import React from "react";

export default function RangeSlider({ label, value, onChange, min, max, step, displayValue }) {
  return (
    <div className="v2-filter-field v2-filter-field--inline">
      <label className="v2-filter-label">{label}</label>
      <div className="v2-filter-range-wrap">
        <input
          type="range"
          className="v2-filter-range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
        />
        <span className="v2-filter-range-value">{displayValue}</span>
      </div>
    </div>
  );
}
